// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"47":"client","733":"op-payment-widget"}[chunkId] + "." + {"47":"b74d03ca3676c721657d","733":"d76839097c1217b4c6f2"}[chunkId] + ".css";
};